// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1kgDm","modalFooterButton":"ModalNotes_modalFooterButton__2VRVx"};